var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.70575 7.41911H9.12619C9.56828 7.41911 9.92667 7.7775 9.92667 8.21959C9.92667 8.66168 9.56828 9.02007 9.12619 9.02007H1.70575C1.26366 9.02007 0.905273 8.66168 0.905273 8.21959C0.905273 7.7775 1.26366 7.41911 1.70575 7.41911Z",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70575 12.5422H20.3037C20.7458 12.5422 21.1042 12.9006 21.1042 13.3427C21.1042 13.7848 20.7458 14.1431 20.3037 14.1431H1.70575C1.26366 14.1431 0.905273 13.7848 0.905273 13.3427C0.905273 12.9006 1.26366 12.5422 1.70575 12.5422Z",
    fill: "#677C95"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4922,
    height: 20.4922,
    fill: "white",
    transform: "translate(0.758789 0.535294)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextUnderline);
export default __webpack_public_path__ + "static/media/text-underline.ed9716e9fcbf8863e0c27d228ecbf954.svg";
export { ForwardRef as ReactComponent };